import { differenceInCalendarDays } from 'date-fns';
import { TZDate } from '@date-fns/tz';

const KST = 'Asia/Seoul';

/**
 * 기준일(ISO 문자열)로부터 "N일째"를 KST 캘린더 기준으로 계산한다.
 *
 * - 기준일 당일 = 1 (1-indexed).
 * - 미래 기준일 → 1 클램프.
 * - invalid/빈 값 → `null` (소비처가 'N일째' 표기를 생략).
 *
 * KST(Asia/Seoul) 캘린더 일수차를 쓰므로, 새벽(00:00~09:00 KST) 윈도우에서
 * raw UTC-epoch 산술이 ±1 어긋나던 off-by-one을 방지한다.
 */
export function solDayFrom(anchorDate: string | null | undefined): number | null {
  if (!anchorDate) return null;
  const anchor = new TZDate(anchorDate, KST);
  if (Number.isNaN(anchor.getTime())) return null;
  const diff = differenceInCalendarDays(new TZDate(Date.now(), KST), anchor);
  return diff < 0 ? 1 : diff + 1;
}

/** SOL 표기 한 벌 — 일수와 그 일수가 무엇부터 센 것인지. */
export interface SolAnchor {
  day: number;
  /** 화면에 그대로 붙는 기준 라벨. */
  label: '입사' | '정규직';
}

/**
 * "N일째"의 기준을 고른다 — 정규직 전환 이력이 있으면 전환일부터, 없으면 입사일부터.
 *
 * 기준을 라벨과 한 벌로 돌려주는 이유: 기준 없이 숫자만 내면 사용자가 전환일 기준으로
 * 읽는다(제보 #121). 소비처가 label을 떼고 쓰지 못하게 묶어 둔다.
 *
 * 전환일이 없는 사용자(경력 입사·미전환·전환 이력 미기록)는 입사 기준으로 떨어진다.
 */
export function solAnchor(
  hireDate: string | null | undefined,
  internConvertedAt?: string | null
): SolAnchor | null {
  const converted = solDayFrom(internConvertedAt);
  if (converted != null) return { day: converted, label: '정규직' };

  const hired = solDayFrom(hireDate);
  return hired != null ? { day: hired, label: '입사' } : null;
}
